export const obj = {
    is: {
        /** obj.has.similarValues(v1, v2, propsToCompare:all)
         * Comparison of two simple objects. Only one-level comparison (not deeper).
         * Not intended for complicated object comparisons with prototypes/etc.
         * Is intended for comparing simple JSON bags of properties. Properties that
         * don't exist at all or that exist but have an undefined value are considered alike.
         * @param {Object} v1 - First object to compare.
         * @param {Object} v2 - Second object to compare.
         * @param {Array} propsToCompare - Array of property names to compare (eg: Object.keys(v1)).
         * @returns {Boolean} - If alike.
         */
        alike(v1, v2, propsToCompare) {
            // If falsy then normalize to empty object.
            v1 = v1 || {};
            v2 = v2 || {};

            if (typeof (v1) !== typeof (v2))
                return false;

            if (!(v1 instanceof Object && v2 instanceof Object))
                return v1 === v2;

            // If no propsToCompare provided that means all properties should be compared,
            // so make sure there are the same amount of property (keys).
            if (!propsToCompare) {
                if (Object.keys(v1).length !== Object.keys(v2).length)
                    return false;

                // Set propsToCompare to the keys of one of the objects.
                propsToCompare = Object.keys(v1);

                // Ensure props are the same in the other object.
                for (const k of Object.keys(v2)) {
                    if (!propsToCompare.includes(k))
                        return false;
                }
            }

            for (const k of propsToCompare) {
                let p1 = v1[k],
                    p2 = v2[k];

                // If the two properties are NOT equal then the objects aren't alike, return false..
                // BUT ONLY if one of the props is truthy, otherwise if both are flasy we consider them alike-enough.
                // This is not as precise as we may like but allows for slightly fuzzy matching on falsy values
                // which is useful when you're comparing an object of undefined/null/0/false values (often used as default values)
                // and the other object has similar or no properties at all for its defaults - ie both are empty-ish.
                if (p1 !== p2 && (p1 || p2))
                    return false;
            }

            return true;
        }
    },
    deepCopy(inObject) {
        let outObject, value, key

        if (typeof inObject !== "object" || inObject === null) {
            return inObject // Return the value if inObject is not an object
        }

        // Create an array or object to hold the values
        outObject = Array.isArray(inObject) ? [] : {}

        for (key in inObject) {
            value = inObject[key]

            // Recursively (deep) copy for nested objects, including arrays
            outObject[key] = this.deepCopy(value)
        }

        return outObject
    }
};